import apiClient from "./config";
import SUBSCRIPTION_ENDPOINTS from "./endpoints/subscriptionEndpoint";

const subscriptionService = {
  subscriptionData: (data) => {
    return apiClient.get(SUBSCRIPTION_ENDPOINTS.GET_SUBSCRIPTION_DATA, { params: data });
  },
 
};

export default subscriptionService;

